<template>
  <v-form ref="form" class="">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-card outlined>
      <v-card-title class="py-2">
        <span class="font-weight-bold body-1">Informações Gerais da NF-e</span>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12" sm="12" md="6">
            <v-autocomplete
              v-model="entry.groundId"
              v-bind="getObject('groundId')"
              label="Área de Emissão"
              :items="extraData.accountContext.allGrounds"
              item-value="id"
              item-text="name"
              @input="groundChanged"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              v-model="entry.taxPayerId"
              v-bind="getObject('taxPayerId')"
              label="Emissor"
              :items="extraData.accountContext.allTaxPayers"
              item-value="id"
              item-text="text"
              @input="taxPayerChanged"
              :disabled="!entry.groundId"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="4" md="3">
            <v-autocomplete
              v-model="entry.series"
              v-bind="getObject('series')"
              label="Série"
              :items="seriesList"
              item-value="number"
              item-text="text"
              @input="retrieveNumberBasedOnSerieAndTaxPayer"
              :disabled="!entry.taxPayerId"
              :loading="seriesListLoading"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="8" md="6">
            <v-text-field
              v-model="entry.number"
              v-bind="getObject('number')"
              label="Número"
              readonly
              :disabled="!entry.taxPayerId"
              :loading="numbersListLoading || seriesListLoading"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3" v-if="entry.status">
            <v-text-field
              v-model="entry.status"
              v-bind="getObject('status')"
              label="Status"
              readonly
            />
          </v-col>


          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              v-model="entry.nfeOperationLocationId"
              v-bind="getObject('nfeOperationLocationId')"
              label="Local da Operação"
              :items="extraData.globalContext.allNfeOperationLocations"
              item-value="id"
              item-text="text"
              autocomplete="off"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="entry.cfopId"
              v-bind="getObject('cfopId')"
              label="CFOP"
              :items="entry.allAvailableCfops"
              item-value="id"
              item-text="text"
              :disabled="!entry.taxPayerId"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <DateField
              :inputData.sync="entry.issueDate"
              v-bind="getObject('issueDate')"
              label="Data de Emissão"
              :hasTodayButton="true"
              :hasTodayDate="true"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <TimeField
              :inputData.sync="entry.issueTime"
              v-bind="getObject('issueTime')"
              label="Hora de Emissão"
              :hasNowButton="true"
              :hasNowTime="true"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <DateField
              :inputData.sync="entry.deliveredReceivedDate"
              v-bind="getObject('deliveredReceivedDate')"
              label="Data de Entrega"
              :hasTodayButton="true"
              :hasTodayDate="true"
              autocomplete="off"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <TimeField
              :inputData.sync="entry.deliveredReceivedTime"
              v-bind="getObject('deliveredReceivedTime')"
              label="Hora de Entrega"
              :hasNowButton="true"
              :hasNowTime="true"
              autocomplete="off"
            />
          </v-col>

          <!-- <v-col cols="12">
            <v-text-field
              v-model="entry.mailingList"
              v-bind="getObject('mailingList')"
              label="E-mail para Recebimento da NF-e"
              clearable
            />
          </v-col> -->

          <v-col cols="12">
            <v-textarea
              v-model="entry.observations"
              v-bind="getObject('observations')"
              label="Observações"
              outlined
            ></v-textarea>
          </v-col>

          <v-col cols="12">
            <v-textarea
              v-model="entry.cashFlowObservations"
              v-bind="getObject('cashFlowObservations')"
              label="Observações da Venda"
              outlined
              :disabled="true"
              autocomplete="off"
            ></v-textarea>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>




    <v-card outlined  v-if="entry.nfeItems" class="mt-4">
      <v-card-title class="py-2">
        <span class="font-weight-bold body-1">Itens da NF-e</span>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12" class="">
            <NfeItemIndex
              :nfeItems="entry.nfeItems"
              :printing="printing"
            />
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>


    <v-card outlined v-if="entry.nfeItems"  class="mt-4">
      <v-card-title class="py-2">
        <span class="font-weight-bold body-1">Totais da NF-e</span>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVbcText"
              label="Base de Cálculo do ICMS"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVbcStText"
              label="Base de Cálculo do ICMS ST"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVfcpText"
              label="Valor Total do FCP (Fundo de Combate à Pobreza)"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVfcpStText"
              label="Valor Total do FCP (Fundo de Combate à Pobreza) retido por substituição tributária"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVfcpStRetText"
              label="Valor Total do FCP retido anteriormente por Substituição Tributária"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVicmsText"
              label="Valor Total do ICMS"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVicmsDesonText"
              label="Valor Total do ICMS desonerado"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.icmsVstText"
              label="Valor Total do ICMS ST"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.pisVpisText"
              label="Valor do PIS"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.cofinsVcofinsText"
              label="Valor da COFINS"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vDescText"
              label="Valor Total do Desconto"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vFreteText"
              label="Valor Total do Frete"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vIiText"
              label="Valor Total do II"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vIpiText"
              label="Valor Total do IPI"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vIpiDevolText"
              label="Valor Total do IPI devolvido"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vSegText"
              label="Valor Total do Seguro"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vOutroText"
              label="Outras Despesas acessórias"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vProdText"
              label="Valor Total dos produtos e serviços"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vTotTribText"
              label="Valor aproximado total de tributos federais, estaduais e municipais"
              readonly
            />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              :value="entry.vNfText"
              label="Valor Total da NF-e"
              readonly
            />
          </v-col>


        </v-row>

      </v-card-text>
    </v-card>



  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import DateField from "@shared_components/date_field.vue"
import TimeField from "@shared_components/time_field.vue"
import gql from 'graphql-tag'
import NfeItemIndex from "@models/fiscal_documents/outbounds/nfes/nfe_items/index.vue"
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      seriesList: [],
      numbersListLoading: false,
      seriesListLoading: false,
      pageLoading: false,
      cashFlowsList: [],
      cashFlowsListLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    printing: {
      type: Boolean,
      default: false
    },
    formType: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    TimeField: TimeField,
    NfeItemIndex: NfeItemIndex,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if (this.entry.series) {
      this.generateSeriesList(this.entry.series);
    }

    if (this.formType == "new" && !this.entry.groundId && this.extraData.accountContext.allGrounds.length == 1) {
      this.entry.groundId = this.extraData.accountContext.allGrounds[0].id;
    }

    if (this.formType == "new" && this.entry.groundId && !this.entry.taxPayerId && this.extraData.accountContext.allTaxPayers.length == 1) {
      this.entry.taxPayerId = this.extraData.accountContext.allTaxPayers[0].id;
      this.taxPayerChanged();
    }

    // seta a operação para operação presencial e deixa sempre assim
    this.entry.nfeOperationLocationId = "2"
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    groundChanged: function() {
      if (this.entry.groundId && this.entry.taxPayerId) {
        this.taxPayerChanged();
      }
    },
    taxPayerChanged: function() {
      let query = null;
      let inputQueryObject = {};
      if (this.formType == "new") {
        query = CALCULATE_NFPE_TAX_VALUES_MUTATION;
        inputQueryObject = {
          input: {
            cashFlowIdsAttribute: this.entry.cashFlowIdsAttribute,
            taxPayerId: this.entry.taxPayerId,
            groundId: this.entry.groundId
          }
        }
      } else {
        query = RECALCULATE_NFPE_TAX_VALUES_MUTATION;
        inputQueryObject = {
          id: this.entry.id,
          input: {
            taxPayerId: this.entry.taxPayerId,
            groundId: this.entry.groundId
          }
        }
      }

      this.calculateNFE(query, inputQueryObject);
    },
    retrieveNumberBasedOnSerieAndTaxPayer: function() {
      // console.log(this.entry.series);
      this.numbersListLoading = true;
      this.$apollo
        .query({
          query: NFE_NUMBER_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            series: this.entry.series,
            taxPayerId: this.entry.taxPayerId
          }
        })
        .then(response => {
          this.entry.number = response.data.accountContext.nfceNumber;
          // console.log(response.data.accountContext.nfceNumber);
        })
        .catch(response => console.log(response))
        .finally(() => (this.numbersListLoading = false));
    },
    generateSeriesList: function(series) {
      let min;
      let max;
      //CPF (920..969) ou CNPJ (1..889)
      if (series >= 1 && series <= 889) { //CNPJ
        min = 1;
        max = 889;
      } else if (series >= 920 && series <= 969) { //CPF
        min = 920;
        max = 969;
      }

      this.seriesList = [];
      for (let i = min; i <= max; i++) {
        this.seriesList.push({
          number: i,
          text: i
        });
      }
    },
    retrieveSeriesAndNumberBasedOnTaxPayer: function () {
      this.seriesListLoading = true;
      this.$apollo
        .query({
          query: NFE_SERIES_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            taxPayerId: this.entry.taxPayerId
          }
        })
        .then(response => {
          // console.log(response.data.accountContext.nfceSeries);

          this.entry.series = response.data.accountContext.nfceSeries.series;
          this.entry.number = response.data.accountContext.nfceSeries.number;
          this.generateSeriesList(this.entry.series);
        })
        .catch(response => console.log(response))
        .finally(() => (this.seriesListLoading = false));
    },
    calculateNFE: function (query, inputObject) {
      // console.log("Tentou calcular NFE");
      if (this.entry.taxPayerId) {
        // console.log("Pode calcular NFE", inputObject);
        // this.pageLoading = true;
        this.$emit("formLoading");
        this.$apollo
          .mutate({
            mutation: query,
            variables: inputObject
          })
          .then(response => {
            // console.log("RESULTADO NFE", response.data);
            let nfpeTaxValues = {};

            if (this.formType == "new") {
              nfpeTaxValues = response.data.calculateNfceTaxValues;
            } else {
              nfpeTaxValues = response.data.reCalculateNfpeTaxValues;
            }

            let errors = nfpeTaxValues.errors;
            if (errors.length) {
              this.$emit("formErrors", errors);
            }
            else {
              Object.assign(this.entry, nfpeTaxValues.nfpe);

              //seta o primeiro cfop como default
              if (this.entry && this.entry.allAvailableCfops && this.entry.allAvailableCfops.length > 0){
                this.entry.cfopId = this.entry.allAvailableCfops[0] ? this.entry.allAvailableCfops[0].id : null;
              }

              // console.log("ENTRY assign", this.entry.nfeItems);

              if (this.formType == "new") {
                this.retrieveSeriesAndNumberBasedOnTaxPayer();
              }
            }
          })
          .catch(error => {
            let { graphQLErrors, networkError, response, operation } = error;
            console.log("error", error)
            console.log("caiu no catch");
            console.log(graphQLErrors);
            console.log(networkError);
            console.log(response);
            console.log(operation);
            if (networkError){
              console.log(`[Network error]: ${networkError}`);
            }
            else if (graphQLErrors){
              graphQLErrors.map(({ message, locations, path }) =>
                console.log(
                  `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
                )
              );
            }
          })
          .finally(() => (this.$emit("formStopLoading")));
      }
    }
  }
};

const NFE_SERIES_QUERY = gql `
  query ($taxPayerId: ID!) {
    accountContext {
      nfceSeries(taxPayerId: $taxPayerId) {
        series
        number
      }
    }
  }
`;

const NFE_NUMBER_QUERY = gql `
  query ($series: Int!, $taxPayerId: ID!) {
    accountContext {
      nfceNumber(series: $series, taxPayerId: $taxPayerId)
    }
  }
`;

const CALCULATE_NFPE_TAX_VALUES_MUTATION = gql `
  mutation($input: CalculateNfpeTaxValuesInputObject!) {
    calculateNfceTaxValues(input: $input) {
      nfpe{
        observations
        allAvailableCfops {
          id
          code
          description
          text
        }
        nfeItems{
          id
          description
          number
          orderCode
          item {
            name
            barcode
            unit {
              name
            }
          }
          packaging{
            unit{
              name
            }
          }
          packagingUnitName
          itemId
          taxationRuleId
          taxationRule {
            id
            operationDestinationTypeName
            taxRegimeTypeName
            icmsOrigin {
              text
            }
            icmsCst {
              text
            }
            icmsPredBc
            icmsPredBcText
            icmsPredBcSt
            icmsPredBcStText
            icmsPicms
            icmsPicmsText
            icmsPicmsSt
            icmsPicmsStText
            icmsPredBc
            icmsPfcp
            icmsPfcpText
            icmsPfcpSt
            icmsPfcpStText
            icmsPdif
            icmsPdifText
            icmsModBc {
              text
            }
            icmsModBcSt {
              text
            }
            pisValiqProd
            pisValiqProdText
            pisPpis
            pisPpisText
            pisCst {
              text
            }
            cofinsValiqProd
            cofinsValiqProdText
            cofinsPcofins
            cofinsPcofinsText
            cofinsCst {
              text
            }
            taxationGroup {
              ncm {
                text
                taxUnit
              }
            }
          }
          quantity
          quantityText
          unitPrice
          unitPriceText
          totalPrice
          totalPriceText
          totalPriceWithExtraValues
          totalPriceWithExtraValuesText
          cofinsVcofins
          discountValue
          icmsVbc
          icmsVbcText
          icmsVbcSt
          icmsVbcStText
          icmsVfcp
          icmsVfcpText
          icmsVfcpSt
          icmsVfcpStText
          icmsVfcpStRet
          icmsVst
          icmsVicmsSt
          icmsVicmsStText
          icmsVicms
          icmsVicmsText
          icmsVicmsDeson
          icmsVicmsOp
          icmsVicmsOpText
          icmsVicmsDif
          icmsVicmsDifText
          icmsVbcFcp
          icmsVbcFcpText
          icmsVbcFcpSt
          icmsVbcFcpStText
					pisVbc
          pisVbcText
          pisVpis
          pisVpisText
          cofinsVbc
          cofinsVbcText
          cofinsVcofins
          cofinsVcofinsText
          carriageValue
          carriageValueText
          insuranceValue
          insuranceValueText
          discountValue
          discountValueText
          otherExpensesValue
          otherExpensesValueText
        }
        cofinsVcofins
        cofinsVcofinsText
        icmsVbc
        icmsVbcText
        icmsVbcSt
        icmsVbcStText
        icmsVfcp
        icmsVfcpText
        icmsVfcpSt
        icmsVfcpStText
        icmsVfcpStRet
        icmsVfcpStRetText
        icmsVicms
        icmsVicmsText
        icmsVicmsDeson
        icmsVicmsDesonText
        icmsVst
        icmsVstText
        pisVpis
        pisVpisText
        status
        vDesc
        vDescText
        vFrete
        vFreteText
        vIi
        vIiText
        vIpi
        vIpiText
        vIpiDevol
        vIpiDevolText
        vSeg
        vSegText
        vOutro
        vOutroText
        vProd
        vProdText
        vTotTrib
        vTotTribText
        vNf
        vNfText
      }
      errors
    }
  }
`;

const RECALCULATE_NFPE_TAX_VALUES_MUTATION = gql `
  mutation($id: ID!, $input: ReCalculateNfpeTaxValuesInputObject!) {
    reCalculateNfpeTaxValues(id: $id, input: $input) {
      nfpe{
        allAvailableCfops {
          id
          code
          description
          text
        }
        nfeItems{
          id
          description
          number
          orderCode
          item {
            name
            barcode
            unit {
              name
            }
          }
          itemId
          packagingUnitName
          taxationRuleId
          taxationRule {
            id
            operationDestinationTypeName
            taxRegimeTypeName
            icmsOrigin {
              text
            }
            icmsCst {
              text
            }
            icmsPredBc
            icmsPredBcText
            icmsPredBcSt
            icmsPredBcStText
            icmsPicms
            icmsPicmsText
            icmsPicmsSt
            icmsPicmsStText
            icmsPredBc
            icmsPfcp
            icmsPfcpText
            icmsPfcpSt
            icmsPfcpStText
            icmsPdif
            icmsPdifText
            icmsModBc {
              text
            }
            icmsModBcSt {
              text
            }
            pisValiqProd
            pisValiqProdText
            pisPpis
            pisPpisText
            pisCst {
              text
            }
            cofinsValiqProd
            cofinsValiqProdText
            cofinsPcofins
            cofinsPcofinsText
            cofinsCst {
              text
            }
            taxationGroup {
              ncm {
                text
                taxUnit
              }
            }
          }
          quantity
          quantityText
          unitPrice
          unitPriceText
          totalPrice
          totalPriceText
          totalPriceWithExtraValues
          totalPriceWithExtraValuesText
          cofinsVcofins
          discountValue
          icmsVbc
          icmsVbcText
          icmsVbcSt
          icmsVbcStText
          icmsVfcp
          icmsVfcpText
          icmsVfcpSt
          icmsVfcpStText
          icmsVfcpStRet
          icmsVst
          icmsVicmsSt
          icmsVicmsStText
          icmsVicms
          icmsVicmsText
          icmsVicmsDeson
          icmsVicmsOp
          icmsVicmsOpText
          icmsVicmsDif
          icmsVicmsDifText
          icmsVbcFcp
          icmsVbcFcpText
          icmsVbcFcpSt
          icmsVbcFcpStText
					pisVbc
          pisVbcText
          pisVpis
          pisVpisText
          cofinsVbc
          cofinsVbcText
          cofinsVcofins
          cofinsVcofinsText
          carriageValue
          carriageValueText
          insuranceValue
          insuranceValueText
          discountValue
          discountValueText
          otherExpensesValue
          otherExpensesValueText
        }
        cofinsVcofins
        cofinsVcofinsText
        icmsVbc
        icmsVbcText
        icmsVbcSt
        icmsVbcStText
        icmsVfcp
        icmsVfcpText
        icmsVfcpSt
        icmsVfcpStText
        icmsVfcpStRet
        icmsVfcpStRetText
        icmsVicms
        icmsVicmsText
        icmsVicmsDeson
        icmsVicmsDesonText
        icmsVst
        icmsVstText
        pisVpis
        pisVpisText
        status
        vDesc
        vDescText
        vFrete
        vFreteText
        vIi
        vIiText
        vIpi
        vIpiText
        vIpiDevol
        vIpiDevolText
        vSeg
        vSegText
        vOutro
        vOutroText
        vProd
        vProdText
        vTotTrib
        vTotTribText
        vNf
        vNfText
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
